import { Graph, Shape, Config, } from '@antv/x6'
// import './shape'
import { Vertices } from '@antv/x6/es/registry/tool/vertices'

// const { Dnd } = Addon
export default class FlowGraph {
  public static graph: Graph
  // private static dnd: any

  public static init(dom:any) {
    Config.track(false);

    this.graph = new Graph({
      container: dom!,
      width: 0,
      height: 0,
      grid: {
        size: 10,
        visible: true,
        type: 'mesh',
      },
      // scroller: {
        // enabled: true,
        // pannable: true,
        // pageBreak: false,
      // },
      panning: {
        enabled: true,
        modifiers: 'shift',
      },
      autoResize: true,
      mousewheel: {
        enabled: true,
        modifiers: ['ctrl', 'meta'],
      },
      selecting: {
        enabled: true,
        multiple: true,
        rubberband: true,
        movable: true,
        showNodeSelectionBox: true,
        filter: (node) => {
          const data = node.getData() as any
          return !(data && (data.parent || data.disableMove))
        },
      },
      connecting: {
        anchor: 'center',
        connectionPoint: 'anchor',
        dangling: false,
        highlight: true,
        snap: true,
        allowBlank: false,
        allowEdge: false,
        allowPort: true,
        allowMulti: 'withPort',
        createEdge() {
          return new Shape.Edge({
            attrs: {
              line: {
                stroke: '#5F95FF',
                strokeWidth: 1,
                sourceMarker: {
                  tagName: 'circle',
                  r: 7,
                  fill: 'none',
                  stroke: '#5F95FF',
                  strokeWidth: 1,
                },
                targetMarker: {
                  tagName: 'circle',
                  r: 7,
                  fill: 'none',
                  stroke: '#5F95FF',
                  strokeWidth: 1,
                },
              },

            },
            router: {
              name: 'manhattan',
              args: {
                startDirections: ['bottom'],
                endDirections: ['top'],
              },
            },
            connector: 'rounded',
          })
        },
        validateConnection({
          sourceView,
          targetView,
          sourceMagnet,
          targetMagnet,
        }) {
          // 不允许自循环
          if (sourceView === targetView) {
            return false
          }
          if (!sourceMagnet) {
            return false
          }
          if (!targetMagnet) {
            return false
          }

          // 每个接口只能接入一次
          if (sourceView && targetView && sourceMagnet && targetMagnet) {
            const sourceNode: any = sourceView.cell;
            const sourcePortId = sourceMagnet.getAttribute('port');
            const targetNode: any = targetView.cell;
            const targetPortId = targetMagnet.getAttribute('port');
            const sourceEdges = FlowGraph.graph.getConnectedEdges(sourceNode) || [];
            const targetEdges = FlowGraph.graph.getConnectedEdges(targetNode) || [];

            // console.log('sourcePortId', sourcePortId, 'targetPortId', targetPortId);

            // 看发起节点侧
            for(const sourceEdge of sourceEdges) {
              const edgeSourcePortID = sourceEdge.getSourcePortId();
              const edgeTargetPortID = sourceEdge.getTargetPortId();
              // console.log(`  sourceEdge: ${edgeSourcePortID} => ${edgeTargetPortID}`);

              // 终点还没有决定的连线是无视的
              if(!edgeTargetPortID) {
                continue;
              }

              // 从该起点已经有一条线段了，不允许发起第二条
              if(sourcePortId === edgeSourcePortID) {
                return false;
              }

              if(targetPortId === edgeTargetPortID) {
                return false;
              }

              if(sourcePortId === edgeTargetPortID) {
                return false;
              }

              if(targetPortId === edgeSourcePortID) {
                return false;
              }
              // console.log('sourceEdge', edgeSourcePortID, edgeTargetPortID);
            }

            // 看终到节点侧
            for(const targetEdge of targetEdges) {
              const edgeSourcePortID = targetEdge.getSourcePortId();
              const edgeTargetPortID = targetEdge.getTargetPortId();

              // 到该终点已经有一条连接了，不允许发起第二条
              if(sourcePortId === edgeSourcePortID) {
                return false;
              }

              if(targetPortId === edgeTargetPortID) {
                return false;
              }

              if(sourcePortId === edgeTargetPortID) {
                return false;
              }

              if(targetPortId === edgeSourcePortID) {
                return false;
              }
              // console.log('targetEdge', edgeSourcePortID, edgeTargetPortID);
            }
          }

          return true
        },
      },
      highlighting: {
        magnetAvailable: {
          name: 'stroke',
          args: {
            padding: 4,
            attrs: {
              strokeWidth: 4,
              stroke: 'rgba(223,234,255)',
            },
          },
        },
      },
      snapline: true,
      history: true,
      clipboard: {
        enabled: true,
      },
      keyboard: {
        enabled: true,
      },
      resizing: false,
      embedding: {
        enabled: true,
        findParent({ node }) {
          const bbox = node.getBBox()
          return this.getNodes().filter((node) => {
            // 只有 data.parent 为 true 的节点才是父节点
            const data = node.getData<any>()
            if (data && data.parent) {
              const targetBBox = node.getBBox()
              return bbox.isIntersectWithRect(targetBBox)
            }
            return false
          })
        },
      },
      interacting: function(cellview) {
        const data = cellview.cell.getData() as any;
        if(data !== undefined && !data.disableMove) {
          return { nodeMovable: true };
        }

        return { nodeMovable: false };
      }
    })
    
    this.initEvent(dom)

    return this.graph;
  }

  private static initEvent(ele:any) {
    const { graph } = this

    graph.on('edge:mouseenter', ({ edge, e }) => {
      edge.addTools([
        {
          name: 'button-remove',
          args: {
            distance: '50%'
          },
        },
      ]);
    })
  

    graph.on('edge:mouseleave', ({ edge }) => {
      edge.removeTools([
        {
          name: 'button-remove',
        },
      ]);
    })

    // graph.on('cell:mouseleave', ({ cell }) => {
    //   if (cell.hasTools('onhover')) {
    //     cell.removeTools()
    //   }
    // })

    // graph.on("node:dblclick", ({ cell, node }) => {
    //   // 加载节点属性集合
    //   const networkAttributes = (node as any).networkAttributes;
    //   if(!networkAttributes) {
    //     return;
    //   }

    //   // 渲染模态框
    //   const deviceType = node.shape;
    //   renderModal(FlowGraph.modalDom, deviceType, networkAttributes, graph, node, cell)
    // })

    // 增加边拖拽工具
    graph.on('edge:click', ({ edge }) => {
      edge.addTools([
        {
          name: 'red-vertices',
        },
      ],
      'red',
      )
    }) 

    graph.on('edge:mouseleave', ({ edge }) => {
      if (edge.hasTools('red')) {
        edge.removeTools()
      }
    })
  }
}

// 增加边拖拽工具
const RedVertices = Vertices.define<Vertices.Options>({
  name: 'red-vertices', // 工具名称，可省略，指定后其大驼峰形式同时作为继承的类的类名。
  attrs: {
    fill: 'red',
  },
})

Graph.registerEdgeTool('red-vertices', RedVertices, true)